import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TrackingDetails } from '../../model/TrackingDetails.model';
import { TrackingService } from '../tracking.service';

@Component({
  selector: 'app-tracking-point',
  templateUrl: './tracking-point.component.html',
  styleUrls: ['./tracking-point.component.scss'],
  providers: [TrackingService]
})


export class TrackingPointComponent implements OnInit {
  changed:boolean;
  trackNumbers: String[]=[];
  trackingDetails: Map<String, TrackingDetails[]> = new Map();
  trackingParam = "";
  details: any
  trackingTable: any = [];

  constructor(private trackingService: TrackingService,private router: Router,private route: ActivatedRoute) { }

  ngOnInit(): void {
    let tracks: string = this.route.snapshot.params['trackingNumber'];
    if(tracks!=null){
      this.trackNumbers = tracks.split(',');
      this.track();
    }

  }

  getValue(key) {
    return this.trackingDetails.get(key) != null ? this.trackingDetails.get(key) : "";
  }

  track() {
    this.trackingTable= [];
    this.trackingParam="";
    console.log("trackNumbers", this.trackNumbers)
    if (this.trackNumbers.keys() != null) {
      this.trackNumbers = this.trackNumbers.filter(function(elem, index, self) {
        return index === self.indexOf(elem);
    })

      this.trackNumbers.forEach(element => {
        this.trackingParam = this.trackingParam + element + ","
      });


      this.trackingService.getTrackingNumberInformation(this.trackingParam).subscribe(
        (data: any) => {
          this.trackingTable = data.tracking;

        },
        (err) => { console.log(err) },
        () => {
          this.trackingTable.forEach(element => {element.checked=false; })
          console.log("tracking result : ", this.trackingTable)
        }
      )

    }
  }

  onChange(value: String){
    this.changed=true;
  }

  check(key) {
    this.trackingTable[this.trackingTable.indexOf(key)].checked=!this.trackingTable[this.trackingTable.indexOf(key)].checked
  }

}
